var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import styled from 'styled-components';
var StyledSvg = styled.svg(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    color: ", ";\n"], ["\n    color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colorIconHeader;
});
export var UserIcon = function () { return (React.createElement(StyledSvg, { viewBox: "0 0 32 32" },
    React.createElement("path", { fill: "currentColor", d: "M23,21.2v1.7c-1.887.1-12.014.1-13.9.1A10.941,10.941,0,0,1,9,21.2,6.415,6.415,0,0,1,14.461,15a4,4,0,0,1-2.085-3.5v-.3A3.94,3.94,0,0,1,16.04,7h.01a3.834,3.834,0,0,1,3.576,4.076l0,.024v.3A4.3,4.3,0,0,1,17.539,15C20.418,15.7,23,18,23,21.2Z" }),
    React.createElement("circle", { fill: "none", cx: "16", cy: "16", r: "16" }),
    React.createElement("circle", { fill: "none", stroke: "currentColor", cx: "16", cy: "16", r: "15.5" }))); };
var templateObject_1;
//# sourceMappingURL=UserIcon.js.map